<template>
  <div class="page-content">
    <!-- 支付结果 -->
    <div class="result-section">
      <div class="section-content">
        <div class="pay-result">
          <template v-if="paySuccess == 1">
            <img src="../../assets/images/icon-pay-success.png" alt="">
            <span>支付成功<em>￥{{ orderInfo && orderInfo.order_info && orderInfo.order_info.order_amount ||  '0.00' }}元</em></span>
          </template>
          <template v-else>
            <img src="../../assets/images/icon-pay-fail.png" alt="">
            <span>支付失败<em>￥{{ orderInfo && orderInfo.order_info && orderInfo.order_info.order_amount ||  '0.00' }}元</em></span>
          </template>
        </div>
        <div class="group-result" v-if="orderType == 2">
          <!--拼团数据展示-->
          <div class="hr-line"></div>
          <div class="heads">
            <img v-for="(item, index) in orderInfo.teamHead" :src="item" alt="">

          </div>
          <span class="desc">{{ timeout ? '平台奖励，免拼鼓励，直接拼团成功！' : '还差'+orderInfo.teamInfo.less+'人，赶快邀请好友来拼单吧！' }}</span>
          <div class="countDown" v-if="timeout == false">
            <div class="left-line"></div>
            <div class="countDown-c">
              <span>剩余</span>
              <div class="countDown-c-t">
                <nut-countdown
                    :end-time="timeData"
                    :show-days="false"
                    @on-end="teamFinish"
                >
                </nut-countdown>
              </div>
              <span>结束</span>

            </div>
            <div class="right-line"></div>
          </div>
          <div class="btn"  @click="$router.replace({ name: 'ODCompleted',query:{id: order_id}  })" >查看订单</div>
        </div>
      </div>
    </div>
    <!-- 订单信息|拼团 -->
    <div class="order-section">
      <div class="section-content" v-if="orderType == 2">
        <div class="st-name">
          <div class="name">
            <img src="../../assets/images/icon_car.png" alt="">
            <span>{{orderInfo.goods_info.store_name}}</span>
          </div>
          <div class="order-number">订单编号：{{orderInfo.order_info.order_sn}}</div>
        </div>
        <div class="class-type">
          <div class="top">
            <span>{{orderInfo.goods_info.goods_name}}</span>
            <div class="group">拼团</div>
          </div>
          <div class="mid">
            <div class="tag">{{orderInfo.goods_info.car_2distribution}}</div>
            <div class="tag">{{orderInfo.goods_info.car_take}}</div>
            <div class="tag">拿本时长{{orderInfo.goods_info.time_long}}天</div>
          </div>
          <div class="bot">
            <span class="old-price"><em class="money">￥{{orderInfo.goods_info.goods_price}}</em>元</span>
            <span class="group-price">{{orderInfo.goods_info.need}}人团：￥{{orderInfo.goods_info.prices}}元</span>
          </div>
        </div>
        <div class="group-rule">
          <div class="rule-content">
            <span>拼团规则</span>
            <span class="rule-text">好友拼单 人满成团 人不满退款</span>
          </div>
        </div>
        <div class="group-info" v-if="paySuccess == 1 && orderInfo.teamInfo.status == '2'">
          <div class="top-line"></div>
          <div class="group-heads">
            <img v-for="(item, index) in orderInfo.teamHead" :src="item" alt="">
          </div>
          <span>拼团成功</span>
        </div>
      </div>
      <div v-if="orderInfo.haswheel > 0" class="luckyDraw" @click="$router.push({ name: 'LuckyDraw'  })"></div>
      <!-- 优惠券 -->
      <div class="section-content"  v-if="orderType == 3">
        <div class="st-name">
          <div class="name">
            <img src="../../assets/images/icon_car.png" alt="">
            <span v-if="orderInfo.coupon_car.type == 1">驾校优惠券</span>
            <span v-else>平台优惠券</span>
          </div>
          <div class="order-number">订单编号：{{orderInfo.order_info.order_sn}}</div>
        </div>
        <div class="class-type coupon">
          <div class="top">
            <span>{{orderInfo.coupon_car.name}}</span>
            <div class="vouchers">券</div>
            <span class="price">￥{{parseFloat(orderInfo.coupon_car.price).toFixed(2) || '0.00'}}元</span>
          </div>
          <div class="mid">
            <div class="tag">{{orderInfo.coupon_car.short_name}}</div>
          </div>
        </div>
      </div>
      <!-- 礼物 -->
      <div class="section-content gift" v-if="orderType == 4">
        <div class="order-number">
          <img src="../../assets/images/icon_bd.png" alt="">
          <span>订单编号：{{orderInfo.order_info.order_sn}}</span>
        </div>
        <div class="gift-info">
          <div class="img-box">
            <img :src="orderInfo.gift.img" alt="">
          </div>
          <span class="gift-name">{{ orderInfo.gift.name }}(打赏{{ orderInfo.gift.nickname }})</span>
          <span>￥{{ orderInfo.gift.price }}<em>元</em></span>
        </div>
      </div>
      <!-- 普通学车班型信息 -->
      <div class="section-content" v-if="orderType == 1">
        <div class="st-name">
          <div class="name">
            <img src="../../assets/images/icon_car.png" alt="">
            <span>{{orderInfo.goods_info.store_name}}</span>
          </div>
          <div class="order-number">订单编号：{{orderInfo.order_info.order_sn}}</div>
        </div>
        <div class="class-type">
          <div class="top">
            <span>{{orderInfo.goods_info.goods_name}}</span>
            <span class="price">￥{{orderInfo.order_info.total_amount}}元</span>
          </div>
          <div class="mid">
            <div class="tag">{{orderInfo.goods_info.car_2distribution}}</div>
            <div class="tag">{{orderInfo.goods_info.car_take}}</div>
            <div class="tag">拿本时长{{orderInfo.goods_info.time_long}}天</div>
          </div>
          <div class="bot">{{orderInfo.goods_info.goods_remark}}</div>
        </div>
      </div>
    </div>
    <!-- 底部操作按钮 -->
    <div class="footer">
      <template v-if="paySuccess">
        <div class="btns" v-if="orderType == 2 && orderInfo.teamInfo.status == '1'">
          <div class="btn scan-code" @click="scanCPShow = true">面对面扫码拼单</div>
          <div class="btn copy-pwd" @click="copy(orderInfo.teamInfo.qrcode1)">复制口令来拼单</div>
        </div>
        <div class="btns" v-else>
          <div class="btn back-home" @click="$router.push({ name: 'Home'  })">返回首页</div>
          <!-- 跳转用户订单页,礼物订单跳转已完成类型,其他订单跳转进行中类型 -->
          <div class="btn look-order" @click="$router.replace({ name: 'ODOngoing',query:{id: order_id}  })">查看订单</div>
        </div>
      </template>
      <template v-else>
        <div class="pay-after" @click="$router.push({ name: 'Home'  })">支付失败，再逛逛</div>
        <div class="btns">
          <div class="btn pay-again" @click="$router.push({ name: 'MyOrder',query:{type:1}  })">重新支付</div>
        </div>
      </template>
    </div>
    <!-- 面对面扫码弹窗 -->
    <nut-popup class="scan-code-popup" closeable close-icon="cross" v-model="scanCPShow" v-if="orderType == 2">
      <div class="popup-content">
        <p class="title">参与“{{orderInfo.teamInfo.nickname}}”的拼单</p>
        <p class="countdown">
          仅剩{{orderInfo.teamInfo.less}}个名额，
          <nut-countdown
            :end-time="timeData"
            :show-days="false"
          >
          </nut-countdown>
          后结束</p>
        <div class="heads">
          <img v-for="(item, index) in orderInfo.teamHead" :src="item" alt="">

        </div>
        <img v-if="orderInfo.teamInfo" :src="orderInfo.teamInfo.qrcode"   alt="" class="qrcode">
        <div class="btn">长按二维码保存，分享好友</div>
      </div>
    </nut-popup>
  </div>
</template>

<script>
import countDown from '../../utils/countDown'
import cache from "@/utils/cache";

export default {
  name: 'PayResults',
  components: {},
  data() {
    return {
      order_id: 0,
      orderInfo: {
        goods_info:{},
        order_info:{},
        userinfo:{},
        coupon_car:{},
        gift:{},
        vrorders:{},
        store_info:{},
        teamInfo:{},
      },
      orderType: 1,
      paySuccess: 1, //支付结果
      scanCPShow: false, //是否显示扫码弹窗
      //下面这三个暂未使用[待完善]
      timeData: null, //倒计时时分秒
      timeout: false, //倒计时是否结束
    }
  },
  created() {
    this.order_id = this.$route.query.order_id;
  },
  methods: {
    // 初始化数据
    initData() {
      this.$ajax.get('m/trade/order_info', {
        id: this.order_id,
        wheel: 1
      }).then(res => {
        document.title = '支付成功';
        this.orderInfo = res;
        this.paySuccess = parseInt(res.order_info.pay_status) == 0 ? 2 : 1;
        switch (parseInt(res.order_prom_type)) {
          case 1219:	//报名学车
            this.orderType = 1;break;
          case 1221:	//拼团学车
            this.orderType = 2;break;
          case 1223:  //优惠卷
            this.orderType = 3;break;
          case 1225:	//礼物
            this.orderType = 4;
            let jiaolian =  cache.get('jiaolian');
            if( jiaolian){
              try{
                let jlJson = JSON.parse(jiaolian);
                this.$router.push({name:'Reward',query:  jlJson })
              }catch (e){

              }



            }
            break;
          default:
            this.$toast.text('订单类型错误~');
            setTimeout(()=>{
              this.$router.push({name:'MyOrder'})
            },2000)
        }
        if(this.orderType == 2){
          if(res.teamInfo.need > res.teamInfo.join){  //团购尚未满员
            //this.scanCPShow = true;
            this.timeData = parseInt(res.teamInfo.found_end_time+'000');
          }
          document.title = '支付结果';
        }
      })
    },
    copy(arcode1){
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', arcode1)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$toast.text('复制成功');
      }
      document.body.removeChild(input)
    },
    teamFinish(){
      this.timeout = true;
      this.$ajax.get('/m/team/comlet_team', {}).then(res => {
        if(this.timeData !== null && this.timeData < new Date().getTime()+2000){
          window.location.reload();
        }
        //this.$toast.text('拼团成功');
      });
    },
  },
  mounted() {
    this.initData()
  }
}
</script>

<style lang="less" scoped>
.page-content {
  width: 100%;
  box-sizing: border-box;
  padding-top: 15px;
  padding-bottom: 70px;

  .result-section {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;

    .section-content {
      width: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      .pay-result {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 15px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 40px;
          height: 40px;
        }

        span {
          margin-top: 10px;
          font-size: 15px;
          color: #333;

          em {
            font-style: normal;
            margin-left: 10px;
          }
        }
      }

      .group-result {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px 15px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .hr-line {
          width: 100%;
          height: 1px;
          background-color: #E2E2E2;
        }

        .heads {
          display: flex;
          margin-top: 20px;

          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-left: 20px;
            border-radius: 50%;
          }

          img:first-child {
            margin-left: 0;
          }
        }

        .desc {
          font-size: 14px;
          color: #333;
          margin-top: 10px;
        }

        .countDown {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: center;

          .left-line {
            width: 48px;
            height: 1px;
            background: linear-gradient(270deg, rgba(51, 51, 51, 1) 0%, rgba(255, 255, 255, 0) 100%);
          }

          .countDown-c {
            margin: 0 10px;
            display: flex;
            align-items: center;

            span {
              font-size: 14px;
              color: #333;
            }

            .countDown-c-t {
              margin: 0 5px;
              display: flex;
              align-items: center;

              div {
                width: 24px;
                height: 24px;
                background-color: #FDE9EB;
                border-radius: 3px;
                line-height: 24px;
                text-align: center;
                font-size: 13px;
                color: #EB273B;
              }

              span {
                margin: 0 4px;
              }
            }
          }

          .right-line {
            width: 48px;
            height: 1px;
            background: linear-gradient(90deg, rgba(51, 51, 51, 1) 0%, rgba(255, 255, 255, 0) 100%);
          }
        }

        .btn {
          width: 95px;
          height: 30px;
          border-radius: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px #3C43EC solid;
          font-size: 15px;
          color: #3C43EC;
          margin-top: 15px;
        }
      }
    }
  }

  .order-section {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 15px;

    .section-content {
      width: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      .st-name {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        flex-direction: column;

        .name {
          display: flex;
          align-items: center;

          span {
            font-size: 15px;
            color: #333;
            margin-left: 5px;
          }
        }

        .order-number {
          margin-top: 5px;
          font-size: 14px;
          color: #999;
          padding-left: 19px
        }
      }

      .class-type {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-top: 1px #E2E2E2 solid;

        .top {
          width: 100%;
          display: flex;
          align-items: center;

          span {
            font-size: 15px;
            color: #333;

            em {
              font-style: normal;
              font-size: 12px;
            }
          }

          .group {
            width: 32px;
            height: 20px;
            background-color: #FF808E;
            border-radius: 3px;
            line-height: 20px;
            text-align: center;
            font-size: 12px;
            color: #fff;
            margin-left: 5px;
          }

          .vouchers {
            width: 32px;
            height: 20px;
            background-color: #6FCBF3;
            border-radius: 3px;
            line-height: 20px;
            text-align: center;
            font-size: 12px;
            color: #fff;
            margin-left: 5px;
          }
        }

        .mid {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;

          .tag {
            height: 20px;
            line-height: 20px;
            background-color: #F8F8F8;
            border-radius: 3px;
            font-size: 12px;
            color: #666;
            margin-right: 5px;
            box-sizing: border-box;
            padding: 0 5px;
          }
        }

        .bot {
          width: 100%;
          margin-top: 10px;
          display: flex;
          align-items: center;
          color: #666;

          .old-price {
            font-size: 14px;
            color: #999;
            margin-right: 10px;

            .money {
              font-style: normal;
              text-decoration: line-through;
              margin-right: 3px;
            }
          }

          .group-price {
            font-size: 14px;
            color: #EB273B;
          }
        }
      }

      .class-type.coupon {
        .top {
          justify-content: space-between;

          .price {
            flex: 1;
            text-align: right;
          }
        }
      }

      .group-rule {
        width: 100%;
        height: 43px;
        box-sizing: border-box;
        padding: 0 10px;

        .rule-content {
          width: 100%;
          height: 100%;
          border-top: 1px #E2E2E2 solid;
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            font-size: 14px;
            color: #333;
          }

          .rule-text {
            color: #999;
          }
        }
      }

      .group-info {
        width: 100%;
        box-sizing: border-box;
        padding: 0 10px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top-line {
          width: 100%;
          height: 1px;
          background-color: #E2E2E2;
        }

        .group-heads {
          display: flex;
          margin-top: 20px;

          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-left: 20px;
            border-radius: 50%;
          }

          img:first-child {
            margin-left: 0;
          }
        }

        span {
          font-size: 14px;
          color: #333;
          margin-top: 10px;
        }
      }
    }

    .section-content.gift {
      width: 100%;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
      border-radius: 3px;

      .order-number {
        width: 100%;
        height: 42px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 10px;

        span {
          font-size: 14px;
          color: #999;
          margin-left: 5px;
        }
      }

      .gift-info {
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        border-top: 1px #E2E2E2 solid;
        padding: 10px;
        display: flex;
        justify-content: space-between;

        .img-box {
          width: 60px;
          height: 60px;
          box-sizing: border-box;
          padding: 8px 5px;
          border-radius: 3px;
          border: 1px #E2E2E2 solid;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        span {
          font-size: 15px;
          color: #333;

          em {
            font-style: normal;
            font-size: 12px;
          }
        }

        .gift-name {
          flex: 1;
          margin-left: 10px;
        }
      }
    }

    .luckyDraw {
      width: 100%;
      height: 100px;
      background-image: url(../../assets/images/placeholder-2.png);
      background-position: center center;
      background-repeat: no-repeat;
      margin-top: 15px;
      background-size: 100%;
    }
  }

  .footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;

    .btns {
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px #E2E2E2 solid;

      .btn {
        width: 48%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 25px;
        font-size: 15px;
        font-weight: bold;
        color: #fff;
      }

      .scan-code {
        background: linear-gradient(45deg, rgba(255, 96, 57, 1) 0%, rgba(255, 176, 91, 1) 100%);
      }

      .copy-pwd {
        background: linear-gradient(45deg, rgba(255, 81, 140, 1) 0%, rgba(255, 122, 136, 1) 100%);
      }

      .back-home {
        border: 1px #3C43EC solid;
        color: #3C43EC;
      }

      .look-order {
        background: linear-gradient(45deg, rgba(60, 67, 236, 1) 0%, rgba(0, 194, 255, 1) 100%);
      }

      .pay-again {
        width: 100%;
        background: linear-gradient(45deg, rgba(255, 96, 57, 1) 0%, rgba(255, 176, 91, 1) 100%);
      }
    }

    .pay-after {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #999;
      text-decoration: underline;
      margin-bottom: 20px;
    }
  }

  .scan-code-popup {
    width: 280px;
    height: 381px;

    .popup-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      padding-top: 40px;

      .title {
        font-size: 15px;
        color: #333;
      }

      .countdown {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }

      .heads {
        display: flex;
        margin-top: 20px;

        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          margin-left: 20px;
          border-radius: 50%;
        }

        img:first-child {
          margin-left: 0;
        }
      }

      .qrcode {
        width: 120px;
        height: 120px;
        object-fit: cover;
        margin-top: 26px;
      }

      .btn {
        width: 190px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: linear-gradient(45deg, rgba(60, 67, 236, 1) 0%, rgba(0, 194, 255, 1) 100%);
        border-radius: 25px;
        font-size: 15px;
        font-weight: bold;
        color: #fff;
        margin-top: 30px;
      }
    }
  }
}
</style>
